import React, { forwardRef, RefObject } from 'react';
import { arc as d3arc } from 'd3';

import { ArcDatum } from '../../types';
import { PieChartProps, PieChartVariant } from './types';
import { StyledPieChart, StyledPieChartEmptyText } from './styles';
import { Arcs } from '../Arcs';
import { empty } from '../../scheme';
import { sizeToDimension } from './utils';
import { useTheme } from '@redsift/design-system';

export const EmptyPieChart = forwardRef<HTMLDivElement, PieChartProps>((props, ref) => {
  const { className, emptyComponent, localeText, size, variant, ...forwardedProps } = props;
  const theme = useTheme();

  const isDonut = variant === PieChartVariant.donut || variant === PieChartVariant.spacedDonut;

  const { width, height, fontSize, innerRadius } = sizeToDimension(size!);
  const externalRadiusPadding = 8;

  const createArc = d3arc<ArcDatum>()
    .innerRadius(isDonut ? innerRadius : 0)
    .outerRadius(width / 2 - externalRadiusPadding);

  return (
    <StyledPieChart {...forwardedProps} className={className} ref={ref as RefObject<HTMLDivElement>}>
      {emptyComponent ?? (
        <>
          <StyledPieChartEmptyText
            $maxWidth={innerRadius * 2}
            $textSize={fontSize / 2}
            $isDonut={isDonut}
            $theme={theme}
          >
            <span>{localeText?.emptyChartText}</span>
          </StyledPieChartEmptyText>
          <svg width={width} height={height}>
            <Arcs
              arcs={[
                {
                  createArc,
                  previousData: {
                    data: {
                      key: '',
                      value: 0,
                    },
                    startAngle: 0,
                    endAngle: 0,
                    padAngle: 0,
                    value: 0,
                    index: 0,
                  },
                  data: {
                    data: {
                      key: 'No Data',
                      value: 0,
                    },
                    index: 0,
                    value: 0,
                    startAngle: 0,
                    endAngle: 2 * Math.PI,
                    padAngle: 0,
                  },
                  dataset: [
                    {
                      data: {
                        key: 'No Data',
                        value: 0,
                      },
                      index: 0,
                      value: 0,
                      startAngle: 0,
                      endAngle: 2 * Math.PI,
                      padAngle: 0,
                    },
                  ],
                  color: empty,
                },
              ]}
              transform={`translate(${width / 2} ${height / 2})`}
            />
          </svg>
        </>
      )}
    </StyledPieChart>
  );
});
